// phoneHelper.js

// Regex patterns
const sriLankanPhoneRegex = /^(?:\+94|0)7\d{8}$/;   // Sri Lanka (mobile only)
const internationalPhoneRegex = /^\+\d{1,3}\d{4,14}$/; // E.164 international

// Normalize number: remove spaces, handle 94 / +94 / 0 prefixes
export const normalizePhone = (phone) => {
  if (!phone) return "";

  // Remove all spaces and non-digit except +
  let normalized = phone.replace(/\s+/g, "").replace(/[^\d+]/g, "");

  // Handle Sri Lankan specific cases
  if (normalized.startsWith("94") && !normalized.startsWith("+94")) {
    normalized = `+${normalized}`; // "9477xxxxxxx" → "+9477xxxxxxx"
  }

  if (normalized.startsWith("0")) {
    // "077xxxxxxx" → "+9477xxxxxxx"
    normalized = `+94${normalized.substring(1)}`;
  }

  return normalized;
};

// Check Sri Lankan phone
export const isSriLankanPhone = (phone) => {
  const normalized = normalizePhone(phone);
  return sriLankanPhoneRegex.test(normalized);
};

// Check international phone
export const isInternationalPhone = (phone) => {
  const normalized = normalizePhone(phone);
  return internationalPhoneRegex.test(normalized) && !isSriLankanPhone(phone);
};

// Generic validation
export const validatePhone = (phone) => {
  return isSriLankanPhone(phone) || isInternationalPhone(phone);
};
